import { throttle } from 'lodash/fp';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import useLocalStorage from '../../../../../hooks/useLocalStorage';
import { ISG_REPORT_VIEW_OPTIONS } from '../../../../../utils/constants';
import useSidePanel from '../../../../SidePanel/hooks/useSidePanel';
import { CLOSE_SIDE_PANEL } from '../../../../SidePanel/store/actions';
import { useAssignments } from '../../hooks/useAssignments';
import useViewportWidth from '../../hooks/useViewportWidth';
import { SectionCards } from '../SectionCard/SectionCards';
import s from './Body.module.css';
import { BodyHeader } from './BodyHeader';

export const Body = ({
  gradebookData,
  settings,
  getLaunchUrl,
  handleLocalLaunch,
  getStudentReportLink,
  hasStudentReport,
  isDropdownOpen,
  searchTerm,
  onSearchChange,
}) => {
  const { isMobile } = useViewportWidth();

  const {
    searchPhrase,
    categories,
    categoryWeights: weights,
  } = useSelector((state) => state.gradebook);

  const { state: sidePanelState, dispatch: sidePanelDispatch } = useSidePanel();

  const { categoriesData, course: courseData } = useAssignments({
    searchTerm,
    gradebookData,
    categories,
    weights,
    settings,
  });

  const [currentView, setCurrentView] = useLocalStorage(
    'selected_isg_report_view_option',
    ISG_REPORT_VIEW_OPTIONS.CATEGORY,
  );

  const handleSetCurrentView = useCallback(
    (updatedView) => {
      setCurrentView(updatedView);
    },
    [setCurrentView],
  );

  const handleSearchChange = (e) => {
    const value = e.target?.value;
    onSearchChange(value);
  };

  const throttledSearchChange = throttle(300, handleSearchChange);

  const resetSearch = () => {
    if (searchPhrase !== '' || searchTerm !== '') {
      if (sidePanelState.open) {
        sidePanelDispatch({ type: CLOSE_SIDE_PANEL });
      }
      onSearchChange('');
    }
  };

  const handleSearchFocus = () => {
    if (sidePanelState.open) {
      sidePanelDispatch({ type: CLOSE_SIDE_PANEL });
    }
  };

  return (
    <div
      className={isMobile ? s.mobileBody : s.dialogBody}
      data-test-id={isMobile ? `isg-mobile-body` : `isg-modal-body`}
    >
      <BodyHeader
        currentView={currentView}
        onViewOptionClick={handleSetCurrentView}
        // Header Search
        throttledSearchChange={throttledSearchChange}
        searchTerm={searchTerm}
        resetSearch={resetSearch}
        handleSearchFocus={handleSearchFocus}
      />
      <SectionCards
        currentView={currentView}
        categoriesData={categoriesData}
        courseData={courseData}
        // Display
        isDropdownOpen={isDropdownOpen}
        // Route Params
        getLaunchUrl={getLaunchUrl}
        handleLocalLaunch={handleLocalLaunch}
        hasStudentReport={hasStudentReport}
        getStudentReportLink={getStudentReportLink}
      />
    </div>
  );
};
